export const THROTTLE_DEFAULT_DURATION = 200
